import { SelectControl } from '@gsa/afp-shared-form-utils';

export function generateVendorAcceptanceForm({ colors, nonLowBidSelected }) {
  let fields = [];
  if(nonLowBidSelected) {
    fields.push({
      id: `nonLowPriceJustification`,
      type: 'textarea',
      required: nonLowBidSelected,
      label: `Non low bid justification`,
      help: {
        before: 'You have selected the non low bid vendor. Please provide justification as to why the low bid\n' +
          '                              is not the lowest bid technically acceptable. (If\n' +
          '                              you have supporting documents, you may upload them\n' +
          '                              along with your funding confirmation documents\n' +
          '                              below.)',
        after:'1000 characters allowed'

      },
      value: '',
      control: {
        maxLength: 1000,
        countdown: true,
        autoGrow: true,
        style: {
          maxWidth: '100%',
        },
      },
    })
  }

  return {
    buttonControls: {
      submit: false,
      cancel: false,
    },
    sections: [
      {
        fields: [
          ...fields,
          {
            id: `makeColor`,
            type: 'select',
            label: 'Select color',
            required: true,
            options: [
              { label: '-select-', value: '-1' },
              ...colors
            ]
          },
        ],
      },
    ],
  };
}